export const FOCUS_SIDE_LEFT = "focus_left";
export const FOCUS_SIDE_RIGHT = "focus_right";

export const RATES_URI = "https://mfx-price-store-dev.s3.ap-southeast-1.amazonaws.com/prices.json"
